import React, { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'

export default function CookieBanner() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const consent = localStorage.getItem('jo_cookies_consent')
    if (!consent) {
      const t = setTimeout(() => setVisible(true), 1800)
      return () => clearTimeout(t)
    }
  }, [])

  const accept = () => { localStorage.setItem('jo_cookies_consent', 'accepted'); setVisible(false) }
  const reject = () => { localStorage.setItem('jo_cookies_consent', 'rejected'); setVisible(false) }

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-6 left-1/2 z-[55] w-full max-w-xl px-4"
          style={{ transform: 'translateX(-50%)', left: '50%' }}
        >
          <div className="bg-neutral-950 border border-neutral-800 px-6 py-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <p className="text-white/55 text-xs leading-relaxed flex-1"
              style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              Usamos cookies técnicas estrictamente necesarias. No rastreamos ni vendemos tus datos.{' '}
              <button onClick={() => {}} className="text-amber-400 underline bg-transparent border-0 text-xs"
                style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                Más información
              </button>
            </p>
            <div className="flex gap-3 shrink-0">
              <button
                onClick={reject}
                data-testid="cookie-reject"
                className="text-white/40 hover:text-white text-xs tracking-[0.2em] uppercase transition-colors bg-transparent border-0"
                style={{ fontFamily: 'JetBrains Mono, monospace' }}
              >
                Rechazar
              </button>
              <button
                onClick={accept}
                data-testid="cookie-accept"
                className="text-black text-xs tracking-[0.2em] uppercase px-4 py-2 transition-colors"
                style={{ fontFamily: 'JetBrains Mono, monospace', background: '#F5A623' }}
              >
                Aceptar
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
